import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'app/styles/main.less';
import 'app/i18n';
import Root from 'app/Root';


const root = createRoot(document.querySelector('#root') as HTMLElement);

root.render(<Root />);
